// Datos de contacto centralizados. Si cambia el WhatsApp, se actualiza SOLO acá
// (antes el número y los datos de pago estaban repetidos en varios componentes).

// Número de WhatsApp en formato internacional, sin "+" ni espacios (para wa.me).
export const WHATSAPP_NUMERO = "59895232111";

// Arma un link de WhatsApp (wa.me) con un mensaje pre-escrito.
export function linkWhatsApp(mensaje) {
  return `https://wa.me/${WHATSAPP_NUMERO}?text=${encodeURIComponent(mensaje || "")}`;
}
